import React from "react";

function AppFooter() {
  return (
    <footer style={{
      width: "100%",
      textAlign: "center",
      padding: "18px 0",
      background: "#e3f0fc",
      color: "#2d3a4a",
      fontWeight: 500,
      fontSize: "1rem",
      borderTop: "1px solid #bcdcff"
    }}>
      © {new Date().getFullYear()} Dringocean
    </footer>
  );
}

export default AppFooter;